import { Box, Button, SVGIcon } from "src/components";

export default function TableOfContentsInline({ tableOfContents = [] }) {
  const scrollToHeading = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  if (!tableOfContents.length) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        mb: 3,
        mt: 1
      }}
    >
      {tableOfContents.map((item, i) => (
        <Button
          key={i}
          size="small"
          variant="outlined"
          onClick={() => scrollToHeading(item.id)}
          sx={{
            borderRadius: 999,
            textTransform: "none",
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 1,
            fontWeight: 600,
            fontSize: "0.85rem",
            whiteSpace: "nowrap",
          }}
        >
          {item.icon && (
            <SVGIcon icon={item.icon} size={25} />
          )}
          {item.text}
        </Button>
      ))}
    </Box>
  );
}
